import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import {
    extractClassNamesFromProps
} from '../Common/extractClassNamesFromProps'
import omit from '../Common/omit'

import * as st from './Input.module.scss'

export enum InputTypes {
    success = 'SUCCESS',
    info = 'INFO',
    warning = 'WARNING',
    error = 'ERROR',
}

export interface InputProps extends BaseComponentProps, React.InputHTMLAttributes<any> {
    use?: InputTypes
}

export const Input: React.ComponentType<InputProps> = props => {
    const use = props.use
    const filteredProps = omit(props, ['use'])
    const className = extractClassNamesFromProps(props, st.input, {
        [st.info]: use === InputTypes.info,
        [st.success]: use === InputTypes.success,
        [st.warning]: use === InputTypes.warning,
        [st.error]: use === InputTypes.error,
    })
    return <input {...filteredProps} className={className} />
}

// Add displayName to preserve the component name on snapshot testing
Input.displayName = 'Input'
